import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useWorkspace } from '@/hooks/useWorkspace';
import { LoadingPage } from '@/components/routing/LoadingPage';
import AppLayout from './AppLayout';

/**
 * WorkspaceLayout ensures a company context is available for all child routes.
 * It handles loading states and redirects if no company is selected.
 */
export const WorkspaceLayout: React.FC = () => {
  const { isReady, currentCompany, companies, isLoadingCompanies } = useWorkspace();

  // Still loading companies
  if (isLoadingCompanies) {
    return <LoadingPage />;
  }

  // No companies - redirect to onboarding
  if (!isLoadingCompanies && companies.length === 0) {
    return <Navigate to="/companies" replace />;
  }

  // Companies loaded but no current company selected yet
  if (!isReady) {
    return <LoadingPage />;
  }

  // Ready - render the app layout with workspace context
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};